import { render, staticRenderFns } from "./oiStatistics.vue?vue&type=template&id=19d7f4bb&scoped=true"
import script from "./oiStatistics.vue?vue&type=script&lang=js"
export * from "./oiStatistics.vue?vue&type=script&lang=js"
import style0 from "./oiStatistics.vue?vue&type=style&index=0&id=19d7f4bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d7f4bb",
  null
  
)

export default component.exports